/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_SaveInputs */

const en_pricing_save = /** @type {(inputs: Pricing_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

const id_pricing_save = /** @type {(inputs: Pricing_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hemat`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Pricing_SaveInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pricing_save = /** @type {((inputs?: Pricing_SaveInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_SaveInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pricing_save(inputs)
	return en_pricing_save(inputs)
});